import {register} from '@shopify/theme-sections';
import {get} from '../../utils/fetch';
import Glide from '@glidejs/glide'; // tslint:disable-line
import {Breakpoints} from '@glidejs/glide/dist/glide.modular.esm'; // tslint:disable-line

const SELECTOR = '.product-recommendations';

async function loadRecommendations(
  url: string,
  element: HTMLElement,
): Promise<void> {
  const text = await get(url).then(response => response.text());

  render(text, element);
}

function render(text: string, element: HTMLElement) {
  const container = document.createElement('div');
  container.innerHTML = text;

  const recommendations = container.querySelector(SELECTOR);
  if (recommendations) {
    element.innerHTML = recommendations.innerHTML;

    initSlider();
  }
}

function initSlider() {
  if (document.querySelector(`${SELECTOR}.glide`)) {
    new Glide(`${SELECTOR}.glide`, {
      bound: true,
      breakpoints: {
        480: {
          gap: 32,
          perView: 1.75,
        },
        1024: {
          gap: 32,
          perView: 2,
        },
        1280: {
          perView: 4,
        },
      },
      gap: 64,
      perView: 4,
      rewind: false,
      type: 'slider',
    }).mount({Breakpoints});
  }
}

register('product-recommendations', {
  onLoad() {
    const section = document.querySelector(SELECTOR) as HTMLElement;
    const parent = section.parentElement;

    if (!section || !parent) {
      return;
    }

    const data = section.dataset;
    const {limit = 5, productId = ''} = data;

    if (!productId) {
      return;
    }

    const requestUrl = `/recommendations/products?section_id=product-recommendations&limit=${limit}&product_id=${productId}`;
    loadRecommendations(requestUrl, parent);
  },
});
